function ensureEndSlash(folder) {
  const lastChar = folder.charAt(folder.length - 1);
  if (lastChar === '/') {
    return folder;
  }

  return `${folder}/`;
}

export default {
  methods: {
    /**
     *  From an object with different localized fields, get the one in the current locale.
     *  Example: { field_es: "Español", field_en: "English"}
     *
     *  @param url {String} Image name or URL
     *  @param folder {String} Folder in images to search in
     *  @return {String || Object} Webpack frendly image route
     */
    $imageUrl(url, folder) {
      if (url.indexOf('https://') > -1) {
        return this.url;
      }

      let uri = url;
      if (uri.indexOf('.') === -1) {
        uri += '.png';
      }
      if (folder) {
        const safeFolder = ensureEndSlash(folder);
        uri = safeFolder + uri;
      }

      const images = require.context('@/assets/img/', true, /\.(png|jpe?g|svg|webp)$/);
      return images(`./${uri}`);
    },
  },
};
